export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";